import { put, takeLatest } from "redux-saga/effects";
import { AxiosError, AxiosResponse } from "axios";
import {
  getAllClientsSuccess,
  getAllClientsFailure,
  getClientDetailsSuccess,
  getClientDetailsFailure,
  getClientAllUsersSuccess,
  getClientAllUsersFailure,
  getTenantAllUsersSuccess,
  getTenantAllUsersFailure,
  getClientUsersFailure,
  getClientUsersSuccess,
  getClientSubDivisionListSuccess,
  getClientSubDivisionListFailure,
  getSubdivisionDetailsSuccess,
  getSubdivisionDetailsFailure,
  getClientDocumentsSuccess,
  getClientDocumentsFailure,
  getProcessesProcedureSuccess,
  getProcessesProcedureFailure,
  getFormsSuccess,
  getFormsFailure,
  getFormDetailsSuccess,
  getFormDetailsFailure,
  getFormDocumentSuccess,
  getFormDocumentFailure,
  getFormDefinedNamesSuccess,
  getFormDefinedNamesFailure,
  getClientFormSectionsSuccess,
  getClientFormSectionsFailure,
  getClientsListFailure,
  getClientsListSuccess,
  getFormListByClientIdSuccess,
  getFormListByClientIdFailure,
  getRushFeesListSuccess,
  getRushFeesListFailure,
  getCurrentClientDetailsSuccess,
  getCurrentClientDetailsFailure,
  getCurrentSubdivisionDetailsSuccess,
  getCurrentSubdivisionDetailsFailure,
  getCurrentClientSubDivisionListSuccess,
  getCurrentClientSubDivisionListFailure,
  getCurrentProcessesProcedureSuccess,
  getCurrentProcessesProcedureFailure,
} from "./slice";
import { CLIENTS_REQUEST } from "./types";
import { axiosInstance } from "../../utils/AxiosInstance";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

function* getAllClients(action: any) {
  const params = {
    ...action.payload,
  };
  try {
    const response: AxiosResponse<any> = yield axiosInstance.get(
      `${API_BASE_URL}/api/v1/clients`,
      {
        params,
      }
    );
    yield put(getAllClientsSuccess({ response: response?.data }));
  } catch (error) {
    const err = error as AxiosError;
    yield put(getAllClientsFailure({ error: err.response?.data }));
  }
}

function* getClientDetails(action: any) {
  const { id } = action.payload;
  try {
    const response: AxiosResponse<any> = yield axiosInstance.get(
      `${API_BASE_URL}/api/v1/clients/${id}`
    );
    yield put(getClientDetailsSuccess({ response: response?.data }));
  } catch (error) {
    const err = error as AxiosError;
    yield put(getClientDetailsFailure({ error: err.response?.data }));
  }
}

function* getClientAllUsers(action: any) {
  const { id } = action.payload;
  try {
    const response: AxiosResponse<any> = yield axiosInstance.get(
      `${API_BASE_URL}/api/v1/users/clients/${id}/list`
    );
    yield put(getClientAllUsersSuccess({ response: response?.data }));
  } catch (error) {
    const err = error as AxiosError;
    yield put(getClientAllUsersFailure({ error: err.response?.data }));
  }
}

function* getTenantAllUsers() {
  try {
    const response: AxiosResponse<any> = yield axiosInstance.get(
      `${API_BASE_URL}/api/v1/users/tenant/list`
    );
    yield put(getTenantAllUsersSuccess({ response: response?.data }));
  } catch (error) {
    const err = error as AxiosError;
    yield put(getTenantAllUsersFailure({ error: err.response?.data }));
  }
}

function* getClientUsers(action: any) {
  const { id, ...params } = action.payload;
  try {
    const response: AxiosResponse<any> = yield axiosInstance.get(
      `${API_BASE_URL}/api/v1/clients/${id}/users`,
      {
        params,
      }
    );
    yield put(getClientUsersSuccess({ response: response?.data }));
  } catch (error) {
    const err = error as AxiosError;
    yield put(getClientUsersFailure({ error: err.response?.data }));
  }
}

function* getClientSubDivisionList(action: any) {
  const { id } = action.payload;
  try {
    const response: AxiosResponse<any> = yield axiosInstance.get(
      `${API_BASE_URL}/api/v1/clients/${id}/sub-divisions`
    );
    yield put(getClientSubDivisionListSuccess({ response: response?.data }));
  } catch (error) {
    const err = error as AxiosError;
    yield put(getClientSubDivisionListFailure({ error: err.response?.data }));
  }
}

function* getClientSubDivisionDetails(action: any) {
  const { id, subDivisionId } = action.payload;
  try {
    const response: AxiosResponse<any> = yield axiosInstance.get(
      `${API_BASE_URL}/api/v1/clients/${id}/sub-divisions/${subDivisionId}`
    );
    yield put(getSubdivisionDetailsSuccess({ response: response?.data }));
  } catch (error) {
    const err = error as AxiosError;
    yield put(getSubdivisionDetailsFailure({ error: err.response?.data }));
  }
}

function* getClientDocuments(action: any) {
  const { id, ...params } = action.payload;
  try {
    const response: AxiosResponse<any> = yield axiosInstance.get(
      `${API_BASE_URL}/api/v1/clients/${id}/documents`,
      {
        params,
      }
    );
    yield put(getClientDocumentsSuccess({ response: response?.data }));
  } catch (error) {
    const err = error as AxiosError;
    yield put(getClientDocumentsFailure({ error: err.response?.data }));
  }
}

function* getProcessesProcedure(action: any) {
  const { id } = action.payload;
  try {
    const response: AxiosResponse<any> = yield axiosInstance.get(
      `${API_BASE_URL}/api/v1/clients/${id}/processes-procedures`
    );
    yield put(getProcessesProcedureSuccess({ response: response?.data }));
  } catch (error) {
    const err = error as AxiosError;
    yield put(getProcessesProcedureFailure({ error: err.response?.data }));
  }
}

function* getForms(action: any) {
  const params = action.payload;
  try {
    const response: AxiosResponse<any> = yield axiosInstance.get(
      `${API_BASE_URL}/api/v1/forms`,
      {
        params,
        paramsSerializer: {
          indexes: null,
        },
      }
    );
    yield put(getFormsSuccess({ response: response?.data }));
  } catch (error) {
    const err = error as AxiosError;
    yield put(getFormsFailure({ error: err.response?.data }));
  }
}

function* getFormDetails(action: any) {
  const { id } = action.payload;
  try {
    const response: AxiosResponse<any> = yield axiosInstance.get(
      `${API_BASE_URL}/api/v1/forms/${id}`
    );
    yield put(getFormDetailsSuccess({ response: response?.data }));
  } catch (error) {
    const err = error as AxiosError;
    yield put(getFormDetailsFailure({ error: err.response?.data }));
  }
}

function* getFormDocument(action: any) {
  const { id } = action.payload;
  try {
    const response: AxiosResponse<any> = yield axiosInstance.get(
      `${API_BASE_URL}/api/v1/forms/${id}/document`
    );
    yield put(getFormDocumentSuccess({ response: response?.data }));
  } catch (error) {
    const err = error as AxiosError;
    yield put(getFormDocumentFailure({ error: err.response?.data }));
  }
}

function* getFormDefinedNames(action: any) {
  const { id } = action.payload;
  try {
    const response: AxiosResponse<any> = yield axiosInstance.get(
      `${API_BASE_URL}/api/v1/forms/${id}/defined-names`
    );
    yield put(getFormDefinedNamesSuccess({ response: response?.data }));
  } catch (error) {
    const err = error as AxiosError;
    yield put(getFormDefinedNamesFailure({ error: err.response?.data }));
  }
}

function* getFormSections(action: any) {
  const { id } = action.payload;
  try {
    const response: AxiosResponse<any> = yield axiosInstance.get(
      `${API_BASE_URL}/api/v1/forms/${id}/sections`
    );
    yield put(getClientFormSectionsSuccess({ response: response?.data }));
  } catch (error) {
    const err = error as AxiosError;
    yield put(getClientFormSectionsFailure({ error: err.response?.data }));
  }
}

function* getClientsList() {
  try {
    const response: AxiosResponse<any> = yield axiosInstance.get(
      `${API_BASE_URL}/api/v1/clients/list`
    );
    yield put(getClientsListSuccess({ response: response?.data }));
  } catch (error) {
    const err = error as AxiosError;
    yield put(getClientsListFailure({ error: err.response?.data }));
  }
}

function* getFormListByClientId(action: any) {
  const params = {
    ...action.payload,
  };
  try {
    const response: AxiosResponse<any> = yield axiosInstance.get(
      `${API_BASE_URL}/api/v1/forms/list`,
      {
        params,
      }
    );
    yield put(getFormListByClientIdSuccess({ response: response?.data }));
  } catch (error) {
    const err = error as AxiosError;
    yield put(getFormListByClientIdFailure({ error: err.response?.data }));
  }
}

function* getRushFeesList() {
  try {
    const response: AxiosResponse<any> = yield axiosInstance.get(
      `${API_BASE_URL}/api/v1/clients/rush-fees/list`
    );
    yield put(getRushFeesListSuccess({ response: response?.data }));
  } catch (error) {
    const err = error as AxiosError;
    yield put(getRushFeesListFailure({ error: err.response?.data }));
  }
}

function* getCurrentClientDetails() {
  try {
    const response: AxiosResponse<any> = yield axiosInstance.get(
      `${API_BASE_URL}/api/v1/clients/current`
    );
    yield put(getCurrentClientDetailsSuccess({ response: response?.data }));
  } catch (error) {
    const err = error as AxiosError;
    yield put(getCurrentClientDetailsFailure({ error: err.response?.data }));
  }
}

function* getCurrentClientSubDivisionList() {
  try {
    const response: AxiosResponse<any> = yield axiosInstance.get(
      `${API_BASE_URL}/api/v1/clients/current/sub-divisions`
    );
    yield put(
      getCurrentClientSubDivisionListSuccess({ response: response?.data })
    );
  } catch (error) {
    const err = error as AxiosError;
    yield put(
      getCurrentClientSubDivisionListFailure({ error: err.response?.data })
    );
  }
}

function* getCurrentClientSubDivisionDetails(action: any) {
  const { subDivisionId } = action.payload;
  try {
    const response: AxiosResponse<any> = yield axiosInstance.get(
      `${API_BASE_URL}/api/v1/clients/current/sub-divisions/${subDivisionId}`
    );
    yield put(
      getCurrentSubdivisionDetailsSuccess({ response: response?.data })
    );
  } catch (error) {
    const err = error as AxiosError;
    yield put(
      getCurrentSubdivisionDetailsFailure({ error: err.response?.data })
    );
  }
}

function* getCurrentProcessesProcedure() {
  try {
    const response: AxiosResponse<any> = yield axiosInstance.get(
      `${API_BASE_URL}/api/v1/clients/current/processes-procedures`
    );
    yield put(
      getCurrentProcessesProcedureSuccess({ response: response?.data })
    );
  } catch (error) {
    const err = error as AxiosError;
    yield put(
      getCurrentProcessesProcedureFailure({ error: err.response?.data })
    );
  }
}

export function* clientsSaga() {
  yield takeLatest(`${CLIENTS_REQUEST}/getAllClientsRequest`, getAllClients);
  yield takeLatest(
    `${CLIENTS_REQUEST}/getClientDetailsRequest`,
    getClientDetails
  );
  yield takeLatest(
    `${CLIENTS_REQUEST}/getClientAllUsersRequest`,
    getClientAllUsers
  );
  yield takeLatest(
    `${CLIENTS_REQUEST}/getTenantAllUsersRequest`,
    getTenantAllUsers
  );
  yield takeLatest(`${CLIENTS_REQUEST}/getClientUsersRequest`, getClientUsers);
  yield takeLatest(
    `${CLIENTS_REQUEST}/getClientSubDivisionListRequest`,
    getClientSubDivisionList
  );
  yield takeLatest(
    `${CLIENTS_REQUEST}/getSubdivisionDetailsRequest`,
    getClientSubDivisionDetails
  );
  yield takeLatest(
    `${CLIENTS_REQUEST}/getClientDocumentsRequest`,
    getClientDocuments
  );
  yield takeLatest(
    `${CLIENTS_REQUEST}/getProcessesProcedureRequest`,
    getProcessesProcedure
  );
  yield takeLatest(`${CLIENTS_REQUEST}/getFormsRequest`, getForms);
  yield takeLatest(`${CLIENTS_REQUEST}/getFormDetailsRequest`, getFormDetails);
  yield takeLatest(
    `${CLIENTS_REQUEST}/getFormDocumentRequest`,
    getFormDocument
  );
  yield takeLatest(
    `${CLIENTS_REQUEST}/getFormDefinedNamesRequest`,
    getFormDefinedNames
  );
  yield takeLatest(
    `${CLIENTS_REQUEST}/getClientFormSectionsRequest`,
    getFormSections
  );
  yield takeLatest(`${CLIENTS_REQUEST}/getClientsListRequest`, getClientsList);
  yield takeLatest(
    `${CLIENTS_REQUEST}/getFormListByClientIdRequest`,
    getFormListByClientId
  );
  yield takeLatest(
    `${CLIENTS_REQUEST}/getRushFeesListRequest`,
    getRushFeesList
  );
  yield takeLatest(
    `${CLIENTS_REQUEST}/getCurrentClientDetailsRequest`,
    getCurrentClientDetails
  );
  yield takeLatest(
    `${CLIENTS_REQUEST}/getCurrentClientSubDivisionListRequest`,
    getCurrentClientSubDivisionList
  );
  yield takeLatest(
    `${CLIENTS_REQUEST}/getCurrentSubdivisionDetailsRequest`,
    getCurrentClientSubDivisionDetails
  );
  yield takeLatest(
    `${CLIENTS_REQUEST}/getCurrentProcessesProcedureRequest`,
    getCurrentProcessesProcedure
  );
}
